import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('charts', {
      distributorId: ({ distributor }) => (distributor ? distributor.id : null),
      distributorName: ({ distributor }) => (distributor ? distributor.name : null),
      state: ({ state }) => state,
      previousCampaignName: ({ previousCampaign }) => (previousCampaign ? previousCampaign.name : null),
      currentCampaignName: ({ currentCampaign }) => (currentCampaign ? currentCampaign.name : null),
      previousCampaignId: ({ previousCampaign }) => (previousCampaign ? previousCampaign.id : null),
      currentCampaignId: ({ currentCampaign }) => (currentCampaign ? currentCampaign.id : null),
    }),

    barChartScalesOptions() {
      return {
        xAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      };
    },

    dataLabelsOptions() {
      // to change any value you could see the docs https://github.com/chartjs/chartjs-plugin-datalabels/blob/1.x/docs/guide/options.md
      return {
        font: { size: 12, weight: 'bold' },
        color: this.colorDark,
        borderWidth: 0,
        borderRadius: 2,
        padding: 1,
        anchor: 'end',
        align: 'top',
        offset: 5,
        formatter: (value, context) => {
          if (Number(value) <= 0) {
            return '';
          }
          return value;
        },
      };
    },
  },

  data() {
    return {
      colorOrange: '#e07a5f',
      colorYellow: '#f2cc8f',
      colorGreen: '#81b29a',
      colorBlue: '#0081a7',
      colorDark: '#3d405b',
      colorLight: '#f4f1de',
    };
  },

  methods: {
    previousCampaignLabel() {
      return `Ventas ${this.previousCampaignName}`;
    },
    projectionsLabel() {
      return `Cant. Proyectada ${this.currentCampaignName}`;
    },
    currentCampaignLabel() {
      return `Ventas ${this.currentCampaignName}`;
    },
  },
};
